import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';

const useSearchMerchants = (params) => useSWRImmutable(params.query ? {
  url: '/dealerships/search',
  headers: { ACCEPT: 'application/vnd.cfs-api.v2' },
  params,
} : null, capsFetcher);

export default useSearchMerchants;
